import { render, staticRenderFns } from "./PdfIndextab2.vue?vue&type=template&id=753380c4"
import script from "./PdfIndextab2.vue?vue&type=script&lang=js"
export * from "./PdfIndextab2.vue?vue&type=script&lang=js"
import style0 from "./PdfIndextab2.vue?vue&type=style&index=0&id=753380c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports